export default function SynapseCircuit() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="-9 -9 170 118"
      vectorEffect="non-scaling-stroke"
      strokeWidth=".5"
      overflow="visible"
      // preserveAspectRatio="none"
      className="stroke-fuchsia-800/50 dark:stroke-fuchsia-100/50 fill-fuchsia-200/50 dark:fill-fuchsia-200/5 drop-shadow-xl h-64 max-w-sm"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="168"
        height="116"
        x="-8"
        y="-8"
        rx="4"
        className="stroke-purple-400/75 fill-[hsl(275deg_100%_96%)] dark:fill-[hsl(270deg_20%_20%)]"
      />
      <path d="m48,11 4,0 m22,0 4,0 m50,11 0,4 m0,22 0,4 m-24,24 -4,0 m-48,0 -4,0 m0,-39 4,0 m11,11 0,4 m0,-30 0,4" />
      <rect width="48" height="48" rx="2" />
      <rect width="22" height="22" x="52" rx="2" />
      <rect width="74" height="22" x="78" rx="2" />
      <rect width="100" height="22" x="52" y="26" rx="2" />
      <rect width="48" height="48" x="0" y="52" rx="2" />
      <rect width="48" height="48" x="52" y="52" rx="2" />
      <rect width="48" height="48" x="104" y="52" rx="2" />
    </svg>
  )
}
